import * as GoverningBodyActions from "./governing-body.actions";

import {createReducer, on} from "@ngrx/store";
import {DahLoadingType} from '@common/components-module/core-components.models';
import {StoredComponentHelperService} from '@common/helpers/stored-component.helper.service';
import {Government_OLD} from '@association/_common/models/government.models';
import {SetAllInitialStates} from '@common/store/actions/core.actions';

export const governingBodyFeatureKey = 'governingBody';

export interface GoverningBodyState {
    items: Government_OLD[],
    listLoading: DahLoadingType
}

export const initialState: GoverningBodyState = {
    items: [],
    listLoading: 'listLoading'
};

export const governingBodyReducer = createReducer(
    initialState,

    on(GoverningBodyActions.loadList, (state) => ({
        ...state,
        listLoading: StoredComponentHelperService.updateListLoading({
            loading: state.listLoading,
            clearState: false,
        }),
    })),

    on(GoverningBodyActions.loadListSuccess, (state, payload) => ({
        ...state,
        items: payload.items,
        listLoading: undefined
    })),

    on(GoverningBodyActions.loadListFailure, (state) => ({
        ...state,
        listLoading: undefined
    })),

    on(SetAllInitialStates, () => ({...initialState}))
);

